import { render, staticRenderFns } from "./addduty.vue?vue&type=template&id=5baa5477&"
import script from "./addduty.vue?vue&type=script&lang=js&"
export * from "./addduty.vue?vue&type=script&lang=js&"
import style0 from "./addduty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports